import { DateTime } from 'luxon';

const YEAR_MONTH_DAY_FORMAT = 'y-MM-dd';

/**
 * Formats a DateTime object to a string with the provided format or with the default format if no format is passed as parameter.
 */
export const formatDateTime = (dateToFormat: DateTime, dateFormat: string = YEAR_MONTH_DAY_FORMAT): string =>
  dateToFormat.toFormat(dateFormat);

/**
 * Calculates the difference (in days) between two dates.
 */
export const calculateDurationBetweenDates = (lateDate: DateTime, earlyDate: DateTime) => {
  const days = lateDate.diff(earlyDate, 'days').days;

  return Math.round(days);
};

/**
 * Formats a Date object to a string in the format requested by analytics e.g. YYYY-MM-DD_HH:mm:ss - 2023-12-31_23:59:59 .
 * @param date - The Date object to format.
 * @return A string representing the formatted date.
 * @example
 * formatDateAnalytics(new Date(2023, 11, 31, 23, 59, 59)); // returns '2023-12-31_23:59:59'
 * */

export const formatDateAnalytics = (date: Date): string => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const seconds = String(date.getSeconds()).padStart(2, '0');

  return `${year}-${month}-${day}_${hours}:${minutes}:${seconds}`;
};
